import { Context } from '@nuxt/types';

const paywall = (ctx: Context) => {
  const adFreeApp = ctx.app.$channelConfig('settings').application.specialFeatures.adFree;
  const channelId = ctx.app.$channelConfig('settings').externalId;
  ctx.app.$instanceConnector('paywall').init({ channelId, adFreeApp });
};

export default paywall;
